import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../store';

@customElement('assistant-list-select')
export class AssistentListSelect extends connect(store)(LitElement) {

	@property({type: Object})
	title = {
		de: '[Titel]',
		en: '[Title]',
		fr: '[Title]'
	};

	@property({type: Array})
	options = [];

	@property({type: Function})
	selected = null;

	@property({type: Function})
	canBeSelected = () => true;

	@property({type: Function})
	isSatisfied = null;

	@property({type: String})
	action = '';

	@property({type: Function})
	callback = null;

	@property({type: Boolean})
	hideDisabled = false

	static styles = [
		css`
			:host {
				width: var(--assistant-widget-width);
			}
			.title {
				display: flex;
				align-items: center;
				font: var(--font-widget-big-title);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 20px;
			}
			.values {
				display: flex;
				flex-direction: column;
				border: none;
				gap: 8px;
				margin-bottom: 20px;
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.lang = state.status.lang;
		this.loggedIn = state.userProfile.data.loggedIn;
	}

	render() {
		const s = store.getState();
		return html`
			<div>
				<div class="title">
					${this.title[this.lang]}
				</div>
				<div class="values ${classMap({notSatisfied: !this.isSatisfied(s)})}">
					${repeat([...this.options],
							(option) => option.id,
							(option) => html`
								${when(!option.requireLogin || (option.requireLogin && this.loggedIn), () => html`
									<assistant-list-select-item .option=${option}
												  .canBeSelected=${this.canBeSelected(s, option.id)}
												  selected=${this.selected(s)}
												  .hideDisabled=${this.hideDisabled}
												  action="${this.action}"
												  .callback=${this.callback}></assistant-list-select-item>`,
									() => null
								)}
							`)}
				</div>
			</div>

		`;
	}
}
